import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceItem\UpdateInvoiceItemVisibilityController::__invoke
* @see app/Http/Controllers/InvoiceItem/UpdateInvoiceItemVisibilityController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}/visibility'
*/
const UpdateInvoiceItemVisibilityController = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateInvoiceItemVisibilityController.url(args, options),
    method: 'patch',
})

UpdateInvoiceItemVisibilityController.definition = {
    methods: ["patch"],
    url: '/api/invoicing/{invoice}/invoice-item/{invoice_item}/visibility',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\InvoiceItem\UpdateInvoiceItemVisibilityController::__invoke
* @see app/Http/Controllers/InvoiceItem/UpdateInvoiceItemVisibilityController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}/visibility'
*/
UpdateInvoiceItemVisibilityController.url = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            invoice_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        invoice_item: typeof args.invoice_item === 'object'
        ? args.invoice_item.id
        : args.invoice_item,
    }

    return UpdateInvoiceItemVisibilityController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{invoice_item}', parsedArgs.invoice_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceItem\UpdateInvoiceItemVisibilityController::__invoke
* @see app/Http/Controllers/InvoiceItem/UpdateInvoiceItemVisibilityController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}/visibility'
*/
UpdateInvoiceItemVisibilityController.patch = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateInvoiceItemVisibilityController.url(args, options),
    method: 'patch',
})

export default UpdateInvoiceItemVisibilityController